export function getPrintableDirectorName(
  director: {
    directorFirstName: string | null;
    directorLastName: string | null;
    directorMiddleName?: string | null;
  } = {
    directorFirstName: null,
    directorLastName: null,
    directorMiddleName: null,
  }
): string {
  if (!director) return '';
  const { directorFirstName, directorMiddleName, directorLastName } = director;
  return [directorFirstName, directorMiddleName, directorLastName]
    .filter(Boolean)
    .join(' ')
    .trim();
}
